import { satisfies } from "semver";
import { useNativeAudioPlayer } from "core/hooks/useNativeAudioPlayer/useNativeAudioPlayer";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { AudioPlayerPopupView } from "../AudioPlayerPopupView/AudioPlayerPopupView";
import { useTrackAudioPlayStart } from "../../../hooks/useTrackAudioPlayStart/useTrackAudioPlayStart";
import { AudioPlayerResource } from "../../../enums/types";

type NativeAudioPlayerPopupProps = {
  resource: AudioPlayerResource;
  onClose: () => void;
  onDone: () => void;
};

export const NativeAudioPlayerPopup = ({ resource, onClose, onDone }: NativeAudioPlayerPopupProps) => {
  const { appVersion } = useMobilePlatform();
  const hasAudioStopSupport = !!appVersion && satisfies(appVersion, process.env.REACT_APP_AUDIO_STOP_VERSION!);
  const { duration, playTime, isPlaying, error, play, pause, stop, onSeekMouseDown, onSeekMouseUp, onSeekChange } = useNativeAudioPlayer({
    src: resource.src,
    title: resource.title,
  });
  const handlePlay = useTrackAudioPlayStart(play);

  return (
    <AudioPlayerPopupView
      resource={resource}
      duration={duration}
      playTime={playTime}
      isPlaying={isPlaying}
      error={error}
      onPlay={handlePlay}
      onPause={pause}
      onStop={hasAudioStopSupport ? stop : pause}
      onSeekMouseDown={onSeekMouseDown}
      onSeekMouseUp={onSeekMouseUp}
      onSeekChange={onSeekChange}
      onClose={onClose}
      onDone={onDone}
    />
  );
};
